module.exports = __webpack_public_path__ + "img/w80b.48015ae5.jpg";